export type FindReplaceOptions = {
  matchCase?: boolean
  wholeCell?: boolean
}

export function cellTextMatchesQuery(
  value: string,
  query: string,
  options: FindReplaceOptions = {},
): boolean {
  const needle = String(query ?? '')
  if (!needle) return false
  const haystack = String(value ?? '')
  const haystackForSearch = options.matchCase ? haystack : haystack.toLowerCase()
  const needleForSearch = options.matchCase ? needle : needle.toLowerCase()
  if (options.wholeCell) return haystackForSearch === needleForSearch
  return haystackForSearch.includes(needleForSearch)
}

export function replaceCellText(
  value: string,
  query: string,
  replacement: string,
  options: FindReplaceOptions = {},
): { changed: boolean; value: string } {
  const needle = String(query ?? '')
  if (!needle) return { changed: false, value }
  const source = String(value ?? '')
  const nextReplacement = String(replacement ?? '')

  if (options.wholeCell) {
    if (!cellTextMatchesQuery(source, needle, options)) return { changed: false, value: source }
    return { changed: true, value: nextReplacement }
  }

  const escaped = needle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  const flags = options.matchCase ? 'g' : 'gi'
  const pattern = new RegExp(escaped, flags)
  const next = source.replace(pattern, nextReplacement)
  return { changed: next !== source, value: next }
}
